export default __webpack_public_path__ + "static/transform-back-069d6740c7619a855f9ada552058f304.webp";